import React, { useState, useEffect } from 'react';
import {
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
    MDBIcon,
    MDBSpinner,
    MDBProgress
} from 'mdb-react-ui-kit';

const TTSGenerationPopup = ({
    isOpen,
    onClose,
    onCancel,
    isMediaFalg,
    isGenerating = false
}) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [progress, setProgress] = useState(0);

    const loadingTexts = [
        "Please wait a moment while we generate your audio file.",
        "We're still processing your request. This may take slightly longer than usual."
    ];

    // Change text after 5 seconds
    useEffect(() => {
        if (isGenerating) {
            const timer = setTimeout(() => {
                setCurrentTextIndex(1);
            }, 5000);

            return () => clearTimeout(timer);
        } else {
            setCurrentTextIndex(0);
        }
    }, [isGenerating]);

    // Simulate progress
    useEffect(() => {
        if (isGenerating) {
            const progressTimer = setInterval(() => {
                setProgress(prev => {
                    if (prev >= 90) return prev; // Stop at 90% until generation is complete
                    return prev + Math.random() * 15;
                });
            }, 1000);

            return () => clearInterval(progressTimer);
        } else {
            setProgress(0);
        }
    }, [isGenerating]);

    const handleClose = () => {
        setCurrentTextIndex(0);
        setProgress(0);
        onClose();
    };

    const handleCancel = () => {
        setCurrentTextIndex(0);
        setProgress(0);
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <MDBModal open={isOpen} onClose={handleClose} tabIndex="-1">
            <MDBModalDialog size="md" centered>
                <MDBModalContent className="tts-generation-popup shadow-5-strong">
                    <MDBModalHeader className="border-0 pb-0">
                        <MDBModalTitle className="d-flex align-items-center">
                            {!isMediaFalg && (<>
                            <MDBIcon
                                fas
                                icon="microphone"
                                className="me-3 text-primary"
                                size="lg"
                            />
                            
                            <div>
                                <h5 className="mb-0">Text-to-Speech Generation</h5>
                                <small className="text-muted">Creating your audio file</small>
                            </div>
                            </>)}
                        </MDBModalTitle>
                    </MDBModalHeader>

                    <MDBModalBody className="text-center py-4">
                        {/* Animated Spinner */}
                        <div className="mb-4">
                            <div className="tts-spinner-container">
                                {/* <MDBSpinner
                                    size="lg"
                                    color="primary"
                                    className="tts-main-spinner"
                                /> */}
                                <div className="tts-main-spinner">

                                    <MDBIcon fas icon="microphone" className="text-primary" size="lg" />
                                </div>
                                <div className="tts-pulse-ring"></div>
                                <div className="tts-pulse-ring delay-1"></div>
                                <div className="tts-pulse-ring delay-2"></div>
                            </div>
                        </div>

                        {/* Loading Text */}
                        <div className="tts-loading-text-container">
                            <p className="tts-loading-text mb-3">
                                {loadingTexts[currentTextIndex]}
                            </p>

                            {/* Animated dots */}
                            <div className="tts-dots">
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                            </div>
                        </div>

                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
};

export default TTSGenerationPopup;
